import { render, staticRenderFns } from "./chipModelSelect.vue?vue&type=template&id=617e6b1e&scoped=true"
import script from "./chipModelSelect.vue?vue&type=script&lang=js"
export * from "./chipModelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e6b1e",
  null
  
)

export default component.exports